import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container mt20" }

import { getCurrentInstance, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getOpenCityListByBrandApi, getCityListWithDisabledApi, addOpenCityApi, delOpenCityApi, getBrandInfoApi } from '@/apis/brand'
import Pagination from '@/components/Pagination.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenCities',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const route = useRoute()
const router = useRouter()

const { brand_name } = route.query

const filters = reactive({
    brand_id: route.query.brand_id as string, // 品牌ID
    province_name: '',
    city_name: '',
    page: 1,
    page_size: 10,
})

// 是否展示“添加城市配规”按钮
const canShip = ref(false)
const getBrandInfo = async () => {
    const { code, data, msg } = await getBrandInfoApi(filters.brand_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    canShip.value = data.can_ship == 1
}
getBrandInfo()

// 获取开通城市列表
const total = ref(0)
const tableData = ref([])
const getTableData = async () => {
    const { code, data, msg } = await getOpenCityListByBrandApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total || 0
}
getTableData()

// 获取所有城市列表，添加了当前品牌是否已开通标识（disabled 为 true 表示已开通，不可再次选中）
const cityList = ref([])
const cityProps = {
    value: 'id',
    label: 'lable',
    children: 'options',
    multiple: true,
    emitPath: false, // 仅返回最后一层
}
const getCityList = async () => {
    const { code, data, msg } = await getCityListWithDisabledApi(filters.brand_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    cityList.value = data
}
getCityList()
const dialogShow = ref(false)
const selectedCity = ref<number[]>([])
const checkAll = ref(false)
const indeterminate = ref(false)

// 收集所有可开通的城市 ID
const getAllEnabledCityIds = () => {
    const ids: number[] = []
    cityList.value.forEach((province: any) => {
        if (province.options) {
            province.options.forEach((city: any) => {
                if (!city.disabled) {
                    ids.push(city.id)
                }
            })
        }
    })
    return ids
}

const handleCheckAll = (val: boolean) => {
    indeterminate.value = false
    if (val) {
        selectedCity.value = getAllEnabledCityIds()
    } else {
        selectedCity.value = []
    }
}

// 监听选中变化，联动复选框状态
watch(selectedCity, (val) => {
    const allIds = getAllEnabledCityIds()
    const checkedCount = val.length
    checkAll.value = allIds.length > 0 && checkedCount === allIds.length
    indeterminate.value = checkedCount > 0 && checkedCount < allIds.length
})

// 保存
const onSave = async () => {
    if (selectedCity.value.length == 0) { return proxy.$message({ type: 'error', message: '请选择开通城市' }) }
    const { code, data, msg } = await addOpenCityApi(filters.brand_id, selectedCity.value.join(',')) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '操作成功' })
    getTableData()
    getCityList()
    onDialogClose()
}
// 删除
const onDel = (id: number) => {
    proxy.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(async () => {
        const { code, data, msg } = await delOpenCityApi(filters.brand_id, id) as any
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        proxy.$message({ type: 'success', message: '删除成功' })
        getTableData()
    })
}
// 关闭弹框，清空数据
const onDialogClose = () => {
    dialogShow.value = false
    selectedCity.value = []
    checkAll.value = false
    indeterminate.value = false
}
const onSearch = () => {
    filters.page = 1
    getTableData()
}
const onPageChange = (val:number) => {
    filters.page = val
    getTableData()
}
const onSizeChange = (val:number) => {
    filters.page_size = val
    getTableData()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(_unref(brand_name)), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.province_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.province_name) = $event)),
        placeholder: "输入省（可模糊搜索）",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.city_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.city_name) = $event)),
        placeholder: "输入市（可模糊搜索）",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogShow.value = true))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("添加开通城市")
        ])),
        _: 1
      }),
      (canShip.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_button, {
              class: "filter-item",
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push(`/brand/distribution-rule?id=${filters.brand_id}&item_type=city&brand_name=${_unref(brand_name)}`)))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("添加城市配规")
              ])),
              _: 1
            }),
            _createVNode(_component_el_row, {
              justify: "end",
              class: "color-danger"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("注意检查品牌配规：当无品牌配规、无城市配规则用户下不了单")
              ])),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "province_name",
          label: "省"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "市"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: ($event: any) => (onDel(scope.row.id))
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("删除")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "添加开通城市",
      modelValue: dialogShow.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogShow).value = $event)),
      "before-close": onDialogClose,
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          plain: "",
          onClick: onDialogClose
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSave
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("保存")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_cascader, {
          options: cityList.value,
          props: cityProps,
          modelValue: selectedCity.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedCity).value = $event)),
          clearable: "",
          filterable: "",
          "show-all-levels": false,
          style: {"width":"100%","max-height":"300px","overflow-y":"auto"}
        }, {
          header: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: checkAll.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checkAll).value = $event)),
              indeterminate: indeterminate.value,
              onChange: handleCheckAll
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode(" 全选 ")
              ])),
              _: 1
            }, 8, ["modelValue", "indeterminate"])
          ]),
          _: 1
        }, 8, ["options", "modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})